
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PlexEnvironment } from '@app/env';
import { ErrorMessage, ErrorService } from 'app/common/services/error.service';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root'})
export class ProjectCustomEndpointService {
  private http = inject(HttpClient);
  private errService = inject(ErrorService);
  public environment = inject(PlexEnvironment);

  private BASE_URL = this.environment.apiUrl;

  public update<T>(endpoint: string, item: T): Promise<Object | ErrorMessage> {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .put(url, item).pipe(
        catchError(err => this.errService.error('Error in Project update', err))
      )
      .toPromise();
  }

  public async create<T>(endpoint: string, item: T): Promise<Object | ErrorMessage> {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .post(url, item, { headers: headers }).pipe(
        catchError(err => this.errService.error('Error in Project create', err))
      )
      .toPromise();
  }

  public publishDraft(endpoint: string): Promise<Object | ErrorMessage> {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .post(url, { headers: headers }).pipe(
        catchError(err => this.errService.handleHTTPError(err))
      )
      .toPromise();
  }

  public async createSnapshot(endpoint: string): Promise<Object | ErrorMessage> {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .post(url, { headers: headers }).pipe(
        catchError(err => this.errService.error('Error in Create Project Parameter Snapshot', err))
      )
      .toPromise();
  }

  public patch(endpoint: string, item): Promise<Object | ErrorMessage> {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .patch(url, item, { headers: headers }).pipe(
        catchError(err => this.errService.error('Error in Project patch', err))
      )
      .toPromise();
  }

  public deactivate(endpoint: string): Promise<Object | ErrorMessage> {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .delete(url, { headers: headers }).pipe(
        catchError(err => this.errService.error('Error in Project deactivate', err))
      )
      .toPromise();
  }

  public generate(endpoint: string): Promise<Object | ErrorMessage> {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .post(url, { headers: headers }).pipe(
        catchError(err => this.errService.error('Error in Project generate', err))
      )
      .toPromise();
  }

  public processCompletions(endpoint: string, item: any): Promise<Object | ErrorMessage> {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .post(url, item, { headers: headers }).pipe(
        catchError(err => this.errService.error('Error Updating Completion Parameters', err))
      )
      .toPromise();
  }

  public processDrilling(endpoint: string, item: any): Promise<Object | ErrorMessage> {
    let url = `${this.BASE_URL}${endpoint}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .post(url, item, { headers: headers }).pipe(
        catchError(err => this.errService.error('Error Updating Drilling Parameters', err))
      )
      .toPromise();
  }
}